var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7234 12.2713C41.0505 9.41087 36.9163 9.41087 35.2433 12.2713C34.0448 14.3205 31.4205 15.0237 29.358 13.8483C26.479 12.2075 22.8987 14.2746 22.8801 17.5883C22.8667 19.9622 20.9456 21.8833 18.5717 21.8967C15.258 21.9153 13.1909 25.4956 14.8317 28.3746C16.0071 30.4372 15.3039 33.0614 13.2547 34.2599C10.3943 35.9329 10.3943 40.0671 13.2547 41.7401C15.3039 42.9386 16.0071 45.5628 14.8317 47.6254C13.1909 50.5044 15.258 54.0847 18.5717 54.1033C20.9456 54.1167 22.8667 56.0378 22.8801 58.4117C22.8987 61.7254 26.479 63.7924 29.358 62.1517C31.4205 60.9763 34.0448 61.6795 35.2433 63.7287C36.9163 66.5891 41.0505 66.5891 42.7235 63.7287C43.922 61.6795 46.5462 60.9763 48.6088 62.1517C51.4878 63.7924 55.0681 61.7254 55.0867 58.4117C55.1001 56.0378 57.0212 54.1167 59.3951 54.1033C62.7088 54.0847 64.7758 50.5044 63.1351 47.6254C61.9597 45.5628 62.6629 42.9386 64.7121 41.7401C67.5725 40.0671 67.5725 35.9329 64.7121 34.2599C62.6629 33.0614 61.9597 30.4372 63.1351 28.3746C64.7758 25.4956 62.7088 21.9153 59.3951 21.8967C57.0212 21.8833 55.1001 19.9622 55.0867 17.5883C55.0681 14.2746 51.4878 12.2075 48.6088 13.8483C46.5462 15.0237 43.9219 14.3205 42.7234 12.2713ZM39.1299 54.0999C47.9377 54.0999 55.0778 46.9599 55.0778 38.1521C55.0778 29.3444 47.9377 22.2043 39.1299 22.2043C30.3222 22.2043 23.1821 29.3444 23.1821 38.1521C23.1821 46.9599 30.3222 54.0999 39.1299 54.0999Z",
    fill: "url(#paint0_linear_2137_19347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7234 12.2713C41.0505 9.41087 36.9163 9.41087 35.2433 12.2713C34.0448 14.3205 31.4205 15.0237 29.358 13.8483C26.479 12.2075 22.8987 14.2746 22.8801 17.5883C22.8667 19.9622 20.9456 21.8833 18.5717 21.8967C15.258 21.9153 13.1909 25.4956 14.8317 28.3746C16.0071 30.4372 15.3039 33.0614 13.2547 34.2599C10.3943 35.9329 10.3943 40.0671 13.2547 41.7401C15.3039 42.9386 16.0071 45.5628 14.8317 47.6254C13.1909 50.5044 15.258 54.0847 18.5717 54.1033C20.9456 54.1167 22.8667 56.0378 22.8801 58.4117C22.8987 61.7254 26.479 63.7924 29.358 62.1517C31.4205 60.9763 34.0448 61.6795 35.2433 63.7287C36.9163 66.5891 41.0505 66.5891 42.7235 63.7287C43.922 61.6795 46.5462 60.9763 48.6088 62.1517C51.4878 63.7924 55.0681 61.7254 55.0867 58.4117C55.1001 56.0378 57.0212 54.1167 59.3951 54.1033C62.7088 54.0847 64.7758 50.5044 63.1351 47.6254C61.9597 45.5628 62.6629 42.9386 64.7121 41.7401C67.5725 40.0671 67.5725 35.9329 64.7121 34.2599C62.6629 33.0614 61.9597 30.4372 63.1351 28.3746C64.7758 25.4956 62.7088 21.9153 59.3951 21.8967C57.0212 21.8833 55.1001 19.9622 55.0867 17.5883C55.0681 14.2746 51.4878 12.2075 48.6088 13.8483C46.5462 15.0237 43.9219 14.3205 42.7234 12.2713ZM39.1299 54.0999C47.9377 54.0999 55.0778 46.9599 55.0778 38.1521C55.0778 29.3444 47.9377 22.2043 39.1299 22.2043C30.3222 22.2043 23.1821 29.3444 23.1821 38.1521C23.1821 46.9599 30.3222 54.0999 39.1299 54.0999Z",
    fill: "url(#paint1_linear_2137_19347)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4551 32.3823L28.9587 35.8787C27.7871 37.0503 27.7871 38.9497 28.9587 40.1213L32.4551 43.6177",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.207 33.9761L40.3865 35.3973L38.7453 38.2399L37.1042 41.0824L36.2836 42.5037",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5117 32.3823L49.0081 35.8787C50.1796 37.0503 50.1796 38.9497 49.0081 40.1213L45.5117 43.6177",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19347",
    x1: 38.9834,
    y1: -8.67035,
    x2: 38.9834,
    y2: 74.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19347",
    x1: 38.9834,
    y1: 10.126,
    x2: -4.24362,
    y2: 50.7696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution4);
export default __webpack_public_path__ + "static/media/awsSolution4.036b892a529653713206d4b1008fab16.svg";
export { ForwardRef as ReactComponent };